import { render, staticRenderFns } from "./signPanel.vue?vue&type=template&id=1522a1ac&scoped=true"
import script from "./signPanel.vue?vue&type=script&lang=js"
export * from "./signPanel.vue?vue&type=script&lang=js"
import style0 from "./signPanel.vue?vue&type=style&index=0&id=1522a1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522a1ac",
  null
  
)

export default component.exports